<template>

  <div
    class     = "annotations-container"
  >

    <template
      v-for      = "marker in markers"
    >

      <!-- Single Frame -->
      <div 
        v-if       = "marker.start === marker.end"
        class      = "annotations-marker"
        :key       = "marker.id"
        :style     = "{
          top:      '64px',
          left:     marker.start + '%', 
        }"
        @mousedown = "onJumpToAnnotation($event, marker);"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
              small
              v-bind    = "attrs"
              v-on      = "on"
              :color    = "marker.color"
            >
              mdi-tag
            </v-icon>
          </template>

          <span>{{ marker.text }}</span>
        </v-tooltip>
      </div>

      <!-- Multi-Frame -->
      <div
        v-else
        class     = "ranged-annotations-marker"
        :key      = "marker.id"
        :style    = "{
          top:          '64px',
          left:         marker.start + '%', 
          right:        (100 - marker.end) + '%',
          borderLeft:   `2px solid ${marker.color}`,
          borderRight:  `2px solid ${marker.color}`,
        }"
        @mousedown = "onJumpToAnnotation($event, marker);"
      >
        <div class="marker-container">

          <!-- Background -->
          <div 
            class   = "marker-background"
            :style  = "{
              background: `${marker.color}`
            }"
          >
          </div>

          <!-- Icon -->
          <v-icon 
            small           
            :color    = "marker.color"
          >
            mdi-tag
          </v-icon>

          <!--

            For the tooltip, we had to put it in a div floating over the background
            and icon, or, under certain conditions, the annotation would not show
            up on the timeline.

          -->

          <!-- Tooltip -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div 
                class   = "marker-background"
                v-bind  = "attrs"
                v-on    = "on"
              >
              </div>
            </template>

            <span>{{ marker.text }}</span>
          </v-tooltip>

        </div>           
      </div>

    </template>

  </div>

</template>

<script>

// #region Imports

/* Telestream */
import {
  SET_IS_ANNOTATION_FLAG_CLICKED
} from '../../../../utils/mutation-types';
import {
  JUMP_TO_TIME,
  PAUSE_VIDEO,
  SCROLL_TO_ANNOTATION
} from '../../../../utils/action-types';

// #endregion Imports

export default {

  // #region Properties

  props: {
    markers: Array
  },
  
  // #endregion Properties

  // #region Methods

  methods: {

    onJumpToAnnotation(event, marker) {
      event.stopPropagation();
      event.preventDefault();
      this.$store.commit(SET_IS_ANNOTATION_FLAG_CLICKED, true);
      this.$store.dispatch(SCROLL_TO_ANNOTATION, marker.id);
      this.$store.dispatch(JUMP_TO_TIME, marker.time);
      this.$store.dispatch(PAUSE_VIDEO);
    },

  }

  // #endregion Methods
  
}

</script>

<style scoped lang="scss">

.annotations-marker {
  position:     absolute;
}

.ranged-annotations-marker {
  position:     absolute;

  .marker-container {
    text-align:   center;

    .marker-background {
      position:     absolute;
      top:          0;
      right:        0;
      bottom:       0;
      left:         0;

      opacity:      0.1;
    }
  }
}

</style>